module.exports = __webpack_public_path__ + "img/banner301.af9337e2.jpeg";